import { render, staticRenderFns } from "./expandable-container.vue?vue&type=template&id=192df516&"
import script from "./expandable-container.vue?vue&type=script&lang=js&"
export * from "./expandable-container.vue?vue&type=script&lang=js&"
import style0 from "./expandable-container.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports